var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { processorNameToInfoProviders } from './infoProviderUtils';
import { format } from 'date-fns';
function filterToParamDateType(name, filter) {
    var params = {};
    var dateFilter = filter;
    params['date_field'] = name;
    switch (dateFilter.kind) {
        case 'equals':
            params["date_from"] = dateFilter.value;
            params["date_to"] = dateFilter.value;
            break;
        case 'greaterThan':
            params["date_from"] = dateFilter.value;
            break;
        case 'lowerThan':
            params["date_to"] = dateFilter.value;
            break;
        case 'between':
        default:
            params["date_from"] = dateFilter.value.from;
            params["date_to"] = dateFilter.value.to;
    }
    return params;
}
export function filtersToParams(filters) {
    var params = {};
    return Object.entries(filters).reduce(function (params, _a) {
        var name = _a[0], filter = _a[1];
        // convert by type
        if (filter.field.type === 'date') {
            params = __assign(__assign({}, params), filterToParamDateType(name, filter));
        }
        else {
            params[name] = filter.value;
        }
        // convert by name
        if (filter.field.name === 'info_provider') {
            var selectFilter = filter;
            params[name] = processorNameToInfoProviders(selectFilter.value);
        }
        return params;
    }, params);
}
export var getDateRangeFiltersFormatted = function (dateRange) {
    return format(dateRange[0], 'dd/MM/yyyy') + " - " + format(dateRange[1], 'dd/MM/yyyy');
};
